import { useLoader } from '@CS/hooks';
import { OPTIONS } from '@/utils/common';
import AvatarPreview from './AvatarPreview';
import ResizedHeadshot from './ResizedHeadshot';
import { useRef, useState, useEffect } from 'react';
import { Preview, Screenshot, Resized } from './AvatarScene.styles';
import type { IAvatarOptions } from '@/components/AvatarOptionsPanel/types';

type AvatarSceneProps = {
  onSubmit: (image: File) => void;
  options: IAvatarOptions;
  baseModelUrl: string;
  submitting: boolean;
  large: boolean;
  tab: string;
};

export const AvatarScene = ({
  baseModelUrl,
  submitting,
  onSubmit,
  options,
  large,
  tab
}: AvatarSceneProps) => {
  const zoomOptions = [OPTIONS.skinColor, OPTIONS.hair, OPTIONS.face];
  const screenshot = useRef<HTMLCanvasElement>(null);
  const resized = useRef<HTMLCanvasElement>(null);
  const canvas = useRef<HTMLCanvasElement>(null);

  const [loading, setLoading] = useState(true);
  const headshot = useRef<ResizedHeadshot>();
  const preview = useRef<AvatarPreview>();
  const loader = useLoader(loading);

  /* const downloadHeadshot = (headshot: File) => {
    const link = document.createElement('a');
    link.setAttribute('download', 'Headshot.png');

    link.href = URL.createObjectURL(headshot);
    document.body.appendChild(link);

    link.click();
    link.remove();
  }; */

  useEffect(() => {
    if (!preview.current || !headshot.current) return;
    if (!submitting) return setLoading(false);

    setLoading(large);

    const screenshot = preview.current.captureScreenshot();

    headshot.current.resize(screenshot).then((headshot) => {
      // downloadHeadshot(headshot);
      onSubmit(headshot);
    });
  }, [submitting]);

  useEffect(() => {
    if (!preview.current) return;
    preview.current.options = options;
  }, [options]);

  useEffect(() => {
    preview.current?.resize(large);
  }, [large]);

  useEffect(() => {
    if (!preview.current) return;
    preview.current.zoom = zoomOptions.includes(tab as OPTIONS);
  }, [tab]);

  useEffect(() => {
    preview.current = new AvatarPreview(
      canvas.current as HTMLCanvasElement,
      baseModelUrl,
      screenshot.current as HTMLCanvasElement,
      options
    );

    headshot.current = new ResizedHeadshot(
      resized.current as HTMLCanvasElement
    );

    preview.current.onLoad = () => setLoading(false);

    return () => preview.current?.dispose();
  }, []);

  return (
    <>
      <Preview ref={canvas} large={large} />
      <Screenshot ref={screenshot} />
      <Resized width="200" height="200" ref={resized} />
      {loader}
    </>
  );
};
